import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, Validators} from "@angular/forms";

@Component({
  selector: 'app-dialog-with-input',
  templateUrl: './dialog-with-input.component.html',
  styleUrls: ['./dialog-with-input.component.scss']
})
export class DialogWithInputComponent implements OnInit {
  reasonControl = new FormControl('', Validators.required);
  constructor(public dialogRef: MatDialogRef<DialogWithInputComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {
    console.log(this.data)
  }
  confirm() {
    this.dialogRef.close(this.reasonControl.value);
  }
}
